import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { AccMentor } from '../acc-mentors-view.part';


export function getColumns(util: UtilityService) {

	const columns: GridColumn<AccMentor, unknown>[] = [
		buildColumn(util, 'Id', row => row.accMentorId, { header: 'accMentorId' }),
		buildColumn(util, 'Id', row => row.accTeamId, { header: 'accTeamId' }),
		buildColumn(util, 'Id', row => row.personId, { header: 'personId' }),
		buildColumn(util, 'Date', row => util.date.fromUTC(row.lastAutoEmailDeliveredUTC), { header: 'Last Auto Email Date', hidden: true }),
		buildColumn(util, 'Text', row => row.fullName, { header: 'Name' }),
		buildColumn(util, 'Text', row => row.teamName, { header: 'Team' }),
		buildColumn(util, 'Text', row => row.ventures, { header: 'Ventures' }),
		buildColumn(util, 'FirstName', row => row.firstName, { header: 'First Name', hidden: true }),
		buildColumn(util, 'LastName', row => row.lastName, { header: 'Last Name', hidden: true }),
		buildColumn(util, 'Phone', row => row.phone, { header: 'Phone', hidden: true }),
		buildColumn(util, 'Email', row => row.email, { header: 'Email', hidden: true }),
		buildColumn(util, 'Text', row => row.cityAndState, { header: 'Location' }),
		buildColumn(util, 'Number', row => row.zip, { header: 'Zip Code', hidden: true }),
		buildColumn(util, 'YesNo', row => !!row.dropout, { header: 'Dropped Out', hidden: true }),
		buildColumn(util, 'Number', row => row.dropout?.dropoutWeek, { header: 'Drop-out Week', hidden: true }),
		buildColumn(util, 'Text', row => row.handbookSigned ? 'Signed' : 'Not Signed', { header: 'Handbook', hidden: true }),
		buildColumn(util, 'Text', row => row.mediaConsentSigned ? 'Signed' : 'Not Signed', { header: 'Media Consent', hidden: true }),
	];


	return columns;

}